export enum GlobalDropdownEvents {
  Close = 'dropdown:close',
}
